import { formatWhatsappToHtml } from '../../../domain/superadmin/whatsappFormat';

export function WhatsappChatBubble({ text }: { text: string }) {
    const html = formatWhatsappToHtml(text);
    return (
        <div className="rounded-lg bg-[#0b141a] p-4">
            <div className="ml-auto max-w-[85%] rounded-lg rounded-tr-none bg-[#005c4b] px-3 py-2 text-sm text-white shadow">
                <div
                    className="whitespace-pre-wrap break-words leading-relaxed [word-break:break-word]"
                    // formatWhatsappToHtml escapes HTML before adding safe markup tags
                    dangerouslySetInnerHTML={{ __html: html }}
                />
                <div className="mt-1 flex items-center justify-end gap-1 text-[10px] text-white/60">
                    <span>12:00</span>
                    <span aria-hidden>✓✓</span>
                </div>
            </div>
        </div>
    );
}
